import { Page } from "components";
import { useApp, useParameter, useService, useSession } from "contexts";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { MessageType, GuestParamType, SessionType } from "types";
import { Enums, Routes } from "utils";

export const Guest = () => {
  const navigate = useNavigate();

  const { token, params } = useParameter<GuestParamType>();
  const { setFeedback, t } = useApp();
  const { login } = useSession();
  const { userService } = useService();

  const navigateToHome = () => navigate(Routes.home);
  const navigateToProfile = () => navigate(Routes.userdashboard);

  // TODO : improve it
  const setSessionAndRedirect = ({
    _id,
    email,
    first_name,
    last_name,
    role,
    settings,
  }) => {
    login({
      id: _id,
      email: email,
      name: `${first_name} ${last_name}`,
      role: role,
      settings,
    } as SessionType);
    navigateToProfile();
  };

  const setFeedbackAndRedirectHome = (message: string) => {
    setFeedback({
      severity: Enums.EnumFeedback.Info,
      message,
    } as MessageType);
    // redirect to home page
    navigateToHome();
  };

  useEffect(() => {
    const runProcess = async () => {
      if (!token) {
        // If token is missing, redirect to error or home
        setFeedbackAndRedirectHome(t.message.feedback.invite.missing_token);
        return;
      }

      if (params) {
        const response = await userService.findById(params.id);

        if (response) {
          setSessionAndRedirect(response);
        } else {
          navigateToHome();
        }
      }
    };

    runProcess();
  }, [params]);

  return <Page.Loader />;
};
